<template>
  <div>
    <div class="card" style="width: 100%">
      <div class="card-body">
        <MenuNavbar :taboption="taboption" />
      </div>
    </div>
  </div>
</template>

<script>
import MenuNavbar from "@/components/global/MenuNavbar.vue";
export default {
  components: {
    MenuNavbar,
  },
  data() {
    return {
      taboption: [
        {
          name: "Admin",
          component: "",
          payload: {},
        },
        {
          name: "Download",
          component: "",
          payload: {},
        },
        {
          name: "Finance",
          component: "",
          payload: {},
        },
        {
          name: "Editor",
          component: "",
          payload: {},
        },
        {
          name: "Store Manager",
          component: "",
          payload: {},
        },
      ],
    };
  },
};
</script>

<style></style>
